import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { DateRange } from "@mui/x-date-pickers-pro";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { UrlUpdateType } from "use-query-params";
import AddedContactsActions from "./AddedContactsActions";
import { individualColumns } from "./individualColumns";
import { PersonRecord, Role } from "./types";

interface PersonRecordsTabProps {
  selectedEntityId?: number;
  setSelectedEntityId: (newValue: string | null | undefined, updateType?: UrlUpdateType) => void;
}

const IndividualContactsTab = ({ selectedEntityId, setSelectedEntityId }: PersonRecordsTabProps) => {
  const today = dayjs();
  const defaultEndDate = today.endOf("day");
  const defaultStartDate = today.subtract(6, "days").startOf("day");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [individualRecords, setIndividualRecords] = useState<PersonRecord[]>([]);
  const [roleList, setRoleList] = useState<Role[]>([]);
  const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([defaultStartDate, defaultEndDate]);

  const fetchPersonRecords = async () => {
    setIsLoading(true);
    const [startDate, endDate] = dateRange;
    const fromParam = (startDate?.startOf("day") || defaultStartDate).format("YYYY-MM-DD");
    const toParam = (endDate?.endOf("day") || defaultEndDate).format("YYYY-MM-DD");

    try {
      const { data } = await axios.get(`/api/clientphonebook/contactHistory/getNewlyAddedContacts?from=${fromParam}&to=${toParam}`);
      setIndividualRecords(data);
    } catch (error) {
      console.error("Error fetching person records", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getAndSetRoles = async () => {
    const { data } = await axios.get(`/api/clientphonebook/roles/search`);
    setRoleList(data);
  };

  useEffect(() => {
    fetchPersonRecords();
  }, [dateRange]);
useEffect(()=>{
  getAndSetRoles();
},[])
  return (
    <>
      <MaterialReactTable
        enableStickyHeader
        columns={individualColumns(roleList)}
        data={individualRecords}
        muiTableBodyRowProps={({ row }) => ({
          sx: { backgroundColor: row.index % 2 === 0 ? "#f4f4f4" : "white" }
        })}
        state={{ isLoading: isLoading }}
        enableGlobalFilter
        enableFacetedValues
        globalFilterFn="includesString"
        renderTopToolbarCustomActions={({ table }) => {
          return (
            <>
              <AddedContactsActions dateRange={dateRange} setDateRange={setDateRange} table={table} />
            </>
          );
        }}
      />
    </>
  );
};

export default IndividualContactsTab;
